import ConvertDetails from './container/index';

export default ConvertDetails;


// WEBPACK FOOTER //
// ./src/components/page/ConvertDetails/index.js